/**
 * A term as a person reads it: the current term's name ("Spring 2027") when
 * `code` is the current term's code, else the code itself. The name is only
 * known for the current term.
 *
 * @param {{ code?: string, name?: string }|null|undefined} currentTerm
 * @param {string|null|undefined} code
 * @returns {string|null|undefined}
 */
export function termLabel(currentTerm, code) {
    return currentTerm?.code === code && currentTerm?.name
        ? currentTerm.name
        : code;
}

/**
 * The current term's own name and year ("Spring 2027"), falling back to its
 * code. Never a generic "Current Term": a person reading a tab or a heading
 * should see which term it is.
 *
 * @param {{ code?: string, name?: string }|null|undefined} term
 * @returns {string}
 */
export function termDisplayName(term) {
    return term?.name || term?.code || '';
}
